export default {
    data() {
        return {
            editorOptions: {
                maxLines: 20,
                fontSize: 14,
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
            },
            trumbowygConfig: {
                semantic: {
                    'div': 'div',
                }
            }
        }
    },
    methods: {
        editorInit: function () {
            require('brace/index')
            require('brace/ext/language_tools')
            require('brace/ext/searchbox')
            require('brace/mode/html')
            require('brace/mode/javascript')
            require('brace/mode/css')
            require('brace/theme/chrome')
        },
    }
}